import { render } from "./KskPoweredBy.vue?vue&type=template&id=ddb055b6&scoped=true"
import script from "./KskPoweredBy.vue?vue&type=script&lang=js"
export * from "./KskPoweredBy.vue?vue&type=script&lang=js"

import "./KskPoweredBy.vue?vue&type=style&index=0&id=ddb055b6&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddb055b6"]])

export default __exports__